import './formLable.css';
import React from 'react';
export const FormLabel = ({ name, label }) => {
  return (
    <label htmlFor={name} className='form-label' dir='rtl'>
      {label}
    </label>
  );
};
